/********************************************************************************
 * Copyright (c) 2024-2026 Axon Ivy AG and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

export namespace GridProperty {
    export const GRID_BACKGROUND_X = '--grid-background-x';
    export const GRID_BACKGROUND_Y = '--grid-background-y';
    export const GRID_BACKGROUND_WIDTH = '--grid-background-width';
    export const GRID_BACKGROUND_HEIGHT = '--grid-background-height';
    export const GRID_BACKGROUND_ZOOM = '--grid-background-zoom';
    export const GRID_COLOR = '--grid-color';
}
